import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


interface WarningDialogProps {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  titulo: string;
  fullscreen?: boolean;
}

export default function FullScreenDialog(props: WarningDialogProps) {
  const { open, onClose, children, titulo, fullscreen = true } = props;

  return (
    <div>
      <Dialog open={open} fullScreen={fullscreen}>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          {titulo}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>{children}</DialogContent>
      </Dialog>
    </div>
  );
}
